import React, { Component } from 'react';
import { Amount } from '../shared';
import './PriceItem.less';

class PriceItem extends Component {
  render() {
    const { price, contact } = this.props;
    let amount = price.qdVal;
    if (contact.credShow) {
      amount = price.k1Calcpx;
    }

    return (
      <tr>
        <td className="qty-col">
          {price.qdQty}
        </td>
        <td className="val-col">
          <Amount amount={amount} />
        </td>
      </tr>
    );
  }
}


export default PriceItem;


// WEBPACK FOOTER //
// ./src/discounts/PriceItem.js